import { Redirect } from 'expo-router';

export default function KursiLearnEntryRoute() {
  return <Redirect href="/learn" />;
}
